/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Attach_SubmitInputs */

const vi_camera_attach_submit = /** @type {(inputs: Camera_Attach_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gắn vào vùng này`)
};

/**

* @param {Camera_Attach_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_attach_submit = /** @type {((inputs?: Camera_Attach_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Attach_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_attach_submit(inputs)
});